<template>
    <div class="intro-body">

        <p> {{ $t('message.Born_in_an_igloo_on') }} </p>
        <span class="link-item">
            <a @click="$store.dispatch('next')">
              {{ $t('message.scroll_down_or_use_a') }}
            </a>
        </span>
    </div>

</template>

<script>
export default {

}
</script>

<style lang="scss">
.intro-body {
    width: 600px;
    height: 388px;
    margin-left: 120px;
    font-family: Georgia;
    font-size: 22px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.45;
    letter-spacing: normal;
    color: #18333c;
    @media only screen and (max-width: 768px) {
      font-size: 16px;
      margin: 48px;
      width: 80%;
    }
    .link-item {
      border-bottom: solid 2px #9a6969;
      cursor: pointer;
      font-family: Rubik-Medium;
      font-size: 14px;
      font-weight: bold;
      color: #18333c;
      text-transform: uppercase;
    }
}
</style>
